/** Champs exigés à la création — les mêmes que le contrôle d’émission. */
import { legalFormIsSociete } from "../legal/mentions";

export type CompanyCreateInput = {
  legal_name: string;
  legal_form: string;
  siret: string;
  address_line: string;
  postal_code: string;
  city: string;
  vat_number: string;
  vat_regime: "standard" | "franchise";
  share_capital: string;
  rcs_city: string;
  country_code: string;
};

export function emptyCompanyCreate(): CompanyCreateInput {
  return {
    legal_name: "",
    legal_form: "",
    siret: "",
    address_line: "",
    postal_code: "",
    city: "",
    vat_number: "",
    vat_regime: "standard",
    share_capital: "",
    rcs_city: "",
    country_code: "FR",
  };
}

export function companyCreateGaps(input: CompanyCreateInput): string[] {
  const missing: string[] = [];
  if (!input.legal_name.trim()) missing.push("nom de l’entreprise");
  if (!input.legal_form.trim()) missing.push("forme juridique (SAS, SARL, EI…)");
  if (input.siret.replace(/\D/g, "").length !== 14) missing.push("SIRET (14 chiffres)");
  if (!input.address_line.trim() || !input.postal_code.trim() || !input.city.trim()) {
    missing.push("adresse complète (rue, code postal, ville)");
  }
  if (input.vat_regime !== "franchise" && !input.vat_number.trim()) {
    missing.push("n° de TVA (ou régime micro)");
  }
  if (legalFormIsSociete(input.legal_form)) {
    if (!input.share_capital.trim()) missing.push("capital social");
    if (!input.rcs_city.trim()) missing.push("RCS / RM (ville du greffe)");
  }
  return missing;
}
